import React, { useEffect, useState } from 'react'
import {
  Box,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material'
import { HiCheckCircle, HiChevronRight } from 'react-icons/hi2'
import { useLocales } from '@plug-core/state'
import CacheClient from '@plug-core/clients/CacheClient'
import BottomSheet from '@components/BottomSheet'
import Touchable from '@components/Touchable'
import { theme } from '@misc/theme'
import { logger } from '@plug-core/logger'

const LocaleSettings = () => {
  const { locales, setUserLocale, setLocales, userLocale } = useLocales()

  const [currencySelectVisible, setCurrencySelectVisible] = useState(false)

  useEffect(() => {
    ;(async () => {
      const client = new CacheClient()

      try {
        const locales = await client.getLocales()
        setLocales(locales)
      } catch (e) {
        logger.error('Failed to fetch locale info', { originalError: e })
      }
    })()
  }, [])

  return (
    <Stack bgcolor="background.paper" spacing={2} mx={2} borderRadius={1}>
      <List>
        <ListItem onClick={() => setCurrencySelectVisible(true)}>
          <ListItemText
            primary="Currency"
            secondary={`${userLocale.currency.code.toUpperCase()} ${userLocale.currency.symbol}`}
          />
          <ListItemSecondaryAction>
            <HiChevronRight />
          </ListItemSecondaryAction>
        </ListItem>
      </List>

      <BottomSheet
        visible={currencySelectVisible}
        onBackdropClick={() => setCurrencySelectVisible(false)}
      >
        <Stack pt={3} pb={4} spacing={2}>
          {locales.map((locale) => (
            <Touchable
              key={locale.currency.code}
              onClick={() => {
                setUserLocale(locale)
                setCurrencySelectVisible(false)
              }}
            >
              <Stack direction="row" alignItems="center" mx={3}>
                <Typography fontSize={18} mr={2}>
                  {locale.flagEmoji}
                </Typography>

                <Typography fontWeight="bold" mr={1.25}>
                  {locale.currency.name}
                </Typography>

                <Typography color="text.secondary">{locale.currency.symbol}</Typography>

                {locale.id === userLocale.id && (
                  <Box ml="auto">
                    <HiCheckCircle size={20} color={theme.palette.rainbow.green} />
                  </Box>
                )}
              </Stack>
            </Touchable>
          ))}
        </Stack>
      </BottomSheet>
    </Stack>
  )
}

export default LocaleSettings
